let timeout

export function debounce(func: () => void, wait: number): void {
  clearTimeout(timeout)
  timeout = setTimeout(func, wait)
}
